import React from 'react';
import { useTranslation } from 'react-i18next';
import { storageController } from '../controllers/StorageController';
import { SUPPORTED_LANGUAGES, isSupportedLanguage } from '../i18n/types';

const LANGUAGE_LABEL_KEYS: Record<string, string> = {
  en: 'languageSwitcher.english',
  es: 'languageSwitcher.spanish',
};

export default function LanguageSwitcher() {
  const { t, i18n } = useTranslation('common');

  const handleChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const { value } = e.target;
    if (!isSupportedLanguage(value)) return;

    i18n.changeLanguage(value);
    storageController.setPreferredLanguage(value);
  };

  return (
    <div className="absolute right-3 top-1/2 -translate-y-1/2 sm:right-4">
      <label htmlFor="language-switcher" className="sr-only">
        {t('languageSwitcher.label')}
      </label>
      <select
        id="language-switcher"
        name="language-switcher"
        value={i18n.language}
        onChange={handleChange}
        aria-label={t('languageSwitcher.label')}
        className="bg-white/10 text-white text-xs sm:text-sm rounded-md border border-white/30 pl-2 pr-1 py-1 focus:outline-none focus:ring-2 focus:ring-white/50 cursor-pointer"
      >
        {SUPPORTED_LANGUAGES.map((code) => (
          <option key={code} value={code} className="text-gray-900">
            {t(LANGUAGE_LABEL_KEYS[code])}
          </option>
        ))}
      </select>
    </div>
  );
}
